import {
  Flex,
  FormLabel,
  Input,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

interface InputFieldProps {
  id: string;
  label?: string;
  extra?: React.ReactNode;
  placeholder?: string;
  type?: string;
  name?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  isDisabled?: boolean;
  isRequired?: boolean;
  autoComplete?: string;
  mb?: string | number;
  [x: string]: unknown;
}

export default function InputField(props: InputFieldProps) {
  const {
    id,
    label,
    extra,
    placeholder,
    type = 'text',
    mb,
    name,
    value,
    onChange,
    onBlur,
    isDisabled,
    isRequired,
    autoComplete,
    ...rest
  } = props;

  const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
  const brandStars = useColorModeValue('brand.500', 'brand.400');

  return (
    <Flex direction="column" mb={mb || '24px'}>
      {label && (
        <FormLabel
          display="flex"
          ms="10px"
          htmlFor={id}
          fontSize="sm"
          color={textColorPrimary}
          fontWeight="bold"
          _hover={{ cursor: 'pointer' }}
        >
          {label}
          {isRequired && (
            <Text fontSize="sm" fontWeight="400" ms="2px" color={brandStars}>
              *
            </Text>
          )}
          <Text fontSize="sm" fontWeight="400" ms="auto">
            {extra}
          </Text>
        </FormLabel>
      )}
      <Input
        {...rest}
        id={id}
        name={name}
        type={type}
        variant="main"
        placeholder={placeholder}
        h="44px"
        maxH="44px"
        fontWeight="500"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        isDisabled={isDisabled}
        isRequired={isRequired}
        autoComplete={autoComplete}
      />
    </Flex>
  );
}
